import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  reports: null,
};

const slice = createSlice({
  name: "report",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REPORTS
    getReportsSuccess(state, action) {
      state.isLoading = false;
      state.reports = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
const appCurrency = localStorage.getItem('app-currency');
export function getReports(
  filterStartDate,
  filterEndDate,
  filterMasterUser,
  filterUser,
  filterProvider
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/dashboard/reports?start_date=${filterStartDate}&end_date=${filterEndDate}&masteruser=${filterMasterUser}&user=${filterUser}&provider=${filterProvider}&currency=${appCurrency}`
      );
      dispatch(slice.actions.getReportsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
